export enum FormType {
  ENTRY = "ENTRY",
  MODULE = "MODULE",
}
